import React, { useState } from 'react';
import { Button, Input, Select, Modal } from 'antd';
import { GoogleOutlined, CheckCircleTwoTone, CloseCircleTwoTone } from '@ant-design/icons';
import { useFetchWrapper } from '_helpers';

export { GoogleSheetForm };

const IMPORT_TYPES = [
    { value: 'students', label: 'Danh sách học sinh' },
    { value: 'teachers', label: 'Danh sách giáo viên' },
    { value: 'subjects', label: 'Danh sách kỹ năng' },
    { value: 'tuition',  label: 'Học phí & gói buổi' },
];

function GoogleSheetForm() {
    const [url, setUrl] = useState('');
    const [importType, setImportType] = useState('students');
    const [loading, setLoading] = useState(false);
    const [modal, setModal] = useState({ visible: false, title: '', result: null });
    const fetchWrapper = useFetchWrapper();

    async function handleImport() {
        if (!url.includes('docs.google.com/spreadsheets')) return;
        setLoading(true);
        try {
            const res = await fetchWrapper.post('/api/upload/gsheet',
                'application/json',
                JSON.stringify({ url, import_type: importType })
            );
            const json = await res.json();
            if (json.status === 'Success') {
                setModal({ visible: true, title: 'Import thành công', result: json.message });
            } else {
                setModal({ visible: true, title: 'Import thất bại', result: json.message });
            }
        } catch (err) {
            setModal({ visible: true, title: 'Lỗi', result: err.message || String(err) });
        } finally {
            setLoading(false);
        }
    }

    const result = modal.result && typeof modal.result === 'object' ? modal.result : null;

    return (
        <div>
            <Select
                value={importType}
                onChange={setImportType}
                options={IMPORT_TYPES}
                style={{ width: '100%', marginBottom: 8 }}
            />
            <Input
                placeholder="https://docs.google.com/spreadsheets/d/..."
                value={url}
                onChange={e => setUrl(e.target.value)}
                style={{ marginBottom: 8 }}
            />
            <Button
                type="primary"
                icon={<GoogleOutlined />}
                onClick={handleImport}
                loading={loading}
                disabled={!url.includes('docs.google.com/spreadsheets')}
            >
                Import từ Google Sheets
            </Button>

            <Modal
                title={modal.title}
                visible={modal.visible}
                onCancel={() => { setModal({ ...modal, visible: false }); window.location.reload(); }}
                footer={null}
                width={600}
            >
                {result ? (
                    <>
                        <CheckCircleTwoTone twoToneColor="#52c41a" /> Thành công: <b>{result.registered?.length || 0}</b>
                        <br />
                        <CloseCircleTwoTone twoToneColor="#eb2f96" /> Thất bại: <b>{result.failed?.length || 0}</b>
                        {result.failed?.length > 0 && (
                            <pre style={{ marginTop: 12, maxHeight: 200, overflow: 'auto', fontSize: 12 }}>
                                {JSON.stringify(result.failed, null, 2)}
                            </pre>
                        )}
                    </>
                ) : (
                    <pre>{typeof modal.result === 'string' ? modal.result : JSON.stringify(modal.result, null, 2)}</pre>
                )}
            </Modal>
        </div>
    );
}
